// extracted by mini-css-extract-plugin
export var cardHeader = "_hb-1";
export var contentCard = "_hb-0";
export var headerActions = "_hb-3";
export var reorderHandle = "_hb-5";
export var titleArea = "_hb-2";
export var titleAreaWithHandle = "_hb-4";